/**
 * StateRenderer Module
 * Renders the list nav based on current state (START, DIMENSION, AREA)
 * Shows/hides areas and topics appropriately
 */

export default class StateRenderer {
  constructor(listNavEl, data, topicScroller) {
    this.listNavEl = listNavEl
    this.data = data
    this.topicScroller = topicScroller
  }

  /**
   * Render the list nav based on the current state
   * @param {Object} state - Current state { type, dimension, area }
   */
  render(state) {
    console.log('[StateRenderer] Rendering state:', state)

    // Get all dimension sections
    const dimensionSections = this.listNavEl.querySelectorAll('.list-nav-dimension')

    dimensionSections.forEach(section => {
      const dimensionHandle = section.getAttribute('data-dimension')
      if (!dimensionHandle) return // Skip divider lines

      const dimensionHeading = section.querySelector('.dimension-heading')
      const areasList = section.querySelector('.areas-list')

      // Update dimension heading active state
      if (state.dimension === dimensionHandle) {
        dimensionHeading?.classList.add('is-active')
      } else {
        dimensionHeading?.classList.remove('is-active')
      }

      // Show/hide areas list based on whether this dimension is active
      if (areasList) {
        if (state.dimension === dimensionHandle && state.type !== 'start') {
          // Show areas for active dimension
          areasList.style.display = 'flex'

          // Update area items
          const areaItems = areasList.querySelectorAll('.area-item')
          areaItems.forEach(areaItem => {
            const areaHandle = areaItem.getAttribute('data-area')
            const topicsList = areaItem.querySelector('.topics-list')
            const areaHeading = areaItem.querySelector('.area-heading')

            // Update area active state
            if (state.area === areaHandle && state.type === 'area') {
              areaItem.classList.add('is-active')

              // Show topics if they exist
              if (topicsList) {
                topicsList.style.display = 'flex'
              }

              // Update track position after layout has settled
              if (areaHeading && this.topicScroller) {
                // Wait for layout to fully settle with multiple rAFs
                requestAnimationFrame(() => {
                  requestAnimationFrame(() => {
                    // Add small delay for CSS transitions to complete
                    setTimeout(() => {
                      this.topicScroller.updateTrackPosition(areaHeading)
                    }, 50)
                  })
                })
              }
            } else {
              areaItem.classList.remove('is-active')

              // Hide topics
              if (topicsList) {
                topicsList.style.display = 'none'
              }
            }
          })
        } else {
          // Hide areas for non-active dimensions
          areasList.style.display = 'none'
        }
      }
    })

    // Update the list nav state attribute
    this.updateStateAttribute(state)
  }

  /**
   * Update the data-list-nav-state attribute to match current state
   * @param {Object} state - Current state
   */
  updateStateAttribute(state) {
    let stateString = 'start'

    if (state.type === 'dimension' && state.dimension) {
      stateString = `dimension:${state.dimension}`
    } else if (state.type === 'area' && state.dimension && state.area) {
      stateString = `area:${state.dimension}:${state.area}`
    }

    this.listNavEl.setAttribute('data-list-nav-state', stateString)
  }

  /**
   * Update data when navigating to a new page
   * @param {Object} newData - New navigation data
   */
  updateData(newData) {
    this.data = newData
    console.log('[StateRenderer] Data updated:', newData)
  }
}
